/**
 * @file        src/hooks/useFlightOffers.js
 * @description GET /flight-offers (convenience fee, auto discounts, coupons) for
 *              the checkout steps BEFORE payment, so Passenger Details and Review
 *              can show the same auto discount + convenience fee the payment page
 *              charges (lib/fareBreakdown.js priceFlightCheckout). Display only —
 *              the server recomputes all of it at initiate.
 *
 *              Keyed on the sign-in and the role because the answer is
 *              AUDIENCE-scoped (CLAUDE.md §9): a retail and a corporate buyer get
 *              different rules, and signing in mid-funnel must re-ask.
 * @author      Kinetika Labs
 * @created     2026-10-05
 * @changelog
 *   - 2026-10-05 Claude — Initial.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchFlightOffers } from '../api/flights.js';
import { useBooking } from '../store/booking.store.js';

const EMPTY = { convenienceFee: null, flightDiscounts: [], coupons: [] };

export default function useFlightOffers() {
  const loggedIn = useBooking((s) => s.loggedIn);
  const role = useBooking((s) => s.role);
  const q = useQuery({
    queryKey: ['flight-offers', loggedIn, role || ''],
    // fetchFlightOffers never throws — a failure is "no fee, no discount".
    queryFn: fetchFlightOffers,
    staleTime: 60_000,
  });
  return q.data || EMPTY;
}
